import { render } from "./RecipeMeta.vue?vue&type=template&id=49a8ce1c"
import script from "./RecipeMeta.vue?vue&type=script&lang=js"
export * from "./RecipeMeta.vue?vue&type=script&lang=js"

import "./RecipeMeta.vue?vue&type=style&index=0&id=49a8ce1c&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__